import React from 'react';

const NoData = () => (
    <div className="no-data">
        <span className="info">&#128712;</span> No data.
    </div>
);

export default NoData;
